import { render, staticRenderFns } from "./MinhaConta.vue?vue&type=template&id=733cc493&scoped=true&lang=pug&"
import script from "./MinhaConta.vue?vue&type=script&lang=js&"
export * from "./MinhaConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733cc493",
  null
  
)

export default component.exports